<form [formGroup]="quizForm">
    <div class="quiz-container">
      <div class="left-pane">
		<ng-container *ngIf="!showTopicSection">
			<div class="ai-source-tabs">
            <label class="input-label">Input Type*</label>
            <div class="tab-buttons">
              <button (click)="setSourceType(_InputTypeQuiz.Prompt)"
                [class.active]="selectedSource === _InputTypeQuiz.Prompt">
                <i class="bi bi-chat-left-dots"></i> Prompt-Based
              </button>
              <button (click)="setSourceType(_InputTypeQuiz.File)"
                [class.active]="selectedSource === _InputTypeQuiz.File">
                <i class="bi bi-file-earmark"></i> File Upload
              </button>
              <button (click)="setSourceType(_InputTypeQuiz.Url)"
                [class.active]="selectedSource === _InputTypeQuiz.Url">
                <i class="bi bi-link-45deg"></i> URL Input
              </button>
            </div>
          </div>

          <!-- Prompt Input -->
          <div class = "input-group" *ngIf="selectedSource === _InputTypeQuiz.Prompt">
            <label class="input-label"> Enter Prompt*</label>
            <textarea formControlName="prompt" class="prompt-textarea"
              placeholder="e.g., Enter a topic or subject to generate a quiz...." ></textarea>
			  <small *ngIf="quizForm.controls['prompt'].errors?.['invalidQuestionText'] &&
                              quizForm.controls['prompt'].touched" class="text-danger smaller-text">
                              Invalid characters used. Please use only letters, numbers, and basic punctuation</small>

               <small *ngIf="quizForm.controls['prompt'].errors?.['onlySpecialCharacters'] &&
                             quizForm.controls['prompt'].touched" class="text-danger smaller-text">
                             Your question must contain at least one letter or number</small>
          </div>

          <!-- File Upload -->
          <div *ngIf="selectedSource === _InputTypeQuiz.File"
            class="upload-section">
            <label class="input-label">Upload file*</label>
            <label class="upload-box">
              <i class="bi bi-cloud-arrow-up"></i>
              <span *ngIf="!fileName">Click to upload PDF, DOCX, or TXT file</span>
			  <div *ngIf="fileName" class="file-info">
                <i class="bi bi-file-earmark-text"></i>
                <span>{{ fileName }}</span>
              </div>
			  <small *ngIf="fileError && !fileName" class="text-danger smaller-text text-center">
                {{ fileError }}</small>

              <input type="file" hidden (change)="onFileSelected($event)" />
            </label>

            <div class="custom-prompt">
              <label
                >Custom Prompt <span class="optional">(Optional)</span></label>
              <textarea
                placeholder="Add any specific topics or focus areas...."
                formControlName="customPrompt">
              </textarea>
            </div>
          </div>

          <!-- URL Input -->
          <div *ngIf="selectedSource === _InputTypeQuiz.Url"
            class="url-input-section">
            <label class="input-label">URL input*</label>
            <div class="input-wrapper">
              <i class="bi bi-link-45deg"></i>
              <input type="text" formControlName="url" placeholder="http://example.com/article"/>
            </div>
			<small *ngIf="selectedSource === _InputTypeQuiz.Url && !quizForm.get('url')?.value 
			&& quizForm.get('url')?.touched" class="text-danger">url is required.</small>

            <label class="input-label">Custom Prompt (Optional)</label>
            <textarea rows="3" formControlName="customPrompt"
              placeholder="Add any specific topics or focus areas...">
            </textarea>
          </div>

          <div class="question-type">
			<app-question-type [selected]="quizForm.get('selectedType')?.value"
            (selectedChange)="quizForm.patchValue({ selectedType: $event })">
             </app-question-type>
          </div>
          <app-difficulty [(selected)]="difficulty"></app-difficulty>

          <div class="question-input-section">
            <label for="questionCount">Number of Questions</label>
            <div class="input-button-row">
              <input id="questionCount" type="number"
                formControlName="questionCount" min="0" max="5"/>
            </div>
			 <small *ngIf="(quizForm.get('questionCount')?.hasError('min') ||  quizForm.get('questionCount')?.hasError('max')) && 
               quizForm.get('questionCount')?.touched" class="text-danger smaller-text">
                Please enter a number between 1 and 5.</small>

				<small *ngIf="quizForm.get('questionCount')?.hasError('required') 
				&& quizForm.get('questionCount')?.touched" class="text-danger smaller-text">
	            Number of questions is required.</small>

            <div class="continue-btn-wrapper">
			<ng-container *hasPermission="PermissionForStudents.QUIZ_CREATE">
              <button class="continue-btn" (click)="topicRecommendation()"
                [disabled]="quizForm.invalid">	
				<div class="btn-content">Continue</div>
              </button>
			  </ng-container>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="showTopicSection">
          <div class="topic-section">
            <label class="input-label fw-bold"
              >Which of these topics would you like to focus on?</label >
              <i class="bi bi-x close-icon" (click)="closePopup()"></i>
            <div class="topic-buttons">
              <button [class.active]="selectedTopics.includes(topic)"
                (click)="onTopicClick(topic)"
                *ngFor="let topic of _topicList">
                {{ topic }}
              </button>
            </div>

            <label class="input-label fw-bold">Add any other topics here...</label>
            <textarea
              placeholder="Specify additional topics or customize focus..."
              formControlName="customTopic"></textarea>

            <div class="generate-btn-wrapper">
				<ng-container *hasPermission="PermissionForStudents.QUIZ_CREATE">
              <button class="generate-btn" (click)="generateQuestionWithAI()">
				<div class="btn-content">Generate Questions</div>
              </button>
			  </ng-container>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="right-pane">
        <app-question-preview
          [isPreviewVisible]="showPreview"
        ></app-question-preview>
      </div>
    </div>
  </form>